import React from 'react';
import styles from './FeatureCard.module.css';
import type { Feature } from '../../data/features';

interface FeatureCardProps {
  feature: Feature;
  index?: number;
}

export function FeatureCard({ feature, index = 0 }: FeatureCardProps) {
  const isImageIcon = feature.icon.endsWith('.svg') || feature.icon.endsWith('.png');
  const hasSecondIcon = feature.icon2;

  return (
    <article
      className={styles.card}
      style={{ animationDelay: `${0.15 * index + 0.4}s` }}
    >
      <div className={`${styles.icon} ${hasSecondIcon ? styles.doubleIcon : ''}`} aria-hidden="true">
        {isImageIcon ? (
          <>
            <img src={feature.icon} alt={feature.iconAlt || feature.title} />
            {hasSecondIcon && <img src={feature.icon2} alt={feature.icon2Alt || ''} />}
          </>
        ) : (
          feature.icon
        )}
      </div>
      <h3 className={styles.title}>{feature.title}</h3>
      <p className={styles.text}>{feature.text}</p>
    </article>
  );
}
